import { Input, Select } from '@alifd/next';
import React, { useState } from 'react';

import MainButton from '@/components/UI/mobile/MainButton';
import commonhelper from '@/lib/commonhelper';

import ShowCameraDetail from './components/ShowCameraDetail';
import styles from './index.module.scss';
const Option = Select.Option;

const CameraFontDesk = () => {
  const [openEditTodoModal, setOpenEditTodoModal] = useState(false);
  const [showOneCamera, setShowOneCamera] = useState({});
  // const [test, setTest] = useState(undefined);

  // const testOption = ['QRCode', 'Barcode', 'Text'];

  const closeEditTodoModal = () => {
    setOpenEditTodoModal(false);
    setShowOneCamera({});
    document.getElementById('cameraFrame').src = '';
  };

  const fakeData = [
    {
      name: '大門',
      url: 'http://txghome.ezcon.com.tw:9999/ezcon/cam/12?time=20260225-150556&camhash=e829be&token=eyJhbGciOiJIUzI1NiIsInR5cCI6ImFjY2VzcyJ9.eyJpYXQiOjE3NjQwNTYwNTksImV4cCI6MTg1ODcyODg1OSwic3ViIjoiQkZWVGRyZnR4N1hEMWluTSIsImp0aSI6IjgyMTEzOTFmLWQ4MWEtNGQ4NC1iZWQ4LTQyMWQxZGZmYTljNCJ9.q0kLw7vHi1ZTv5z2VcptTfVvktcsFNKLlW-nffLeBzg',
    },
    {
      name: '會議',
      url: 'http://txghome.ezcon.com.tw:9999/ezcon/cam/8?time=20260225-150644&camhash=836279&token=eyJhbGciOiJIUzI1NiIsInR5cCI6ImFjY2VzcyJ9.eyJpYXQiOjE3NjQwNTYwNTksImV4cCI6MTg1ODcyODg1OSwic3ViIjoiQkZWVGRyZnR4N1hEMWluTSIsImp0aSI6IjgyMTEzOTFmLWQ4MWEtNGQ4NC1iZWQ4LTQyMWQxZGZmYTljNCJ9.q0kLw7vHi1ZTv5z2VcptTfVvktcsFNKLlW-nffLeBzg',
    },
  ];
  return openEditTodoModal ? (
    <ShowCameraDetail
      closeModal={closeEditTodoModal}
      showOneCamera={showOneCamera}
    />
  ) : (
    <>
      <div className={styles.container}>
        {fakeData.map((value) => (
          <>
            <MainButton
              // style={}
              style={{ marginBottom: '2vw' }}
              onClick={() => {
                setOpenEditTodoModal(true);
                setShowOneCamera(value);
              }}
            >
              {value.name}
            </MainButton>
          </>
        ))}
      </div>
      {/* 20240905 QRCode測試成功 */}
      {/* <div>
        <Select
          onChange={async (value) => {
            const andTest = await commonhelper.androidScanner(value);
            const iosTest = await commonhelper.iosScanner(value);
            console.log(andTest, '===andTest');
            console.log(iosTest, '====iosTest');
            setTest(andTest ? andTest : iosTest);
          }}
        >
          {testOption.map((item) => (
            <Option key={item} value={item}>
              {item}
            </Option>
          ))}
        </Select>
        <Input value={test} />
      </div> */}
    </>
  );
};

export default CameraFontDesk;
